export const TASK_TYPE_TEST = 'test';
export const TASK_TYPE_TEST_PRO = 'test_pro';
export const TASK_TYPE_EXPERT = 'expert';
export const TASK_TYPE_ASSESSMENT = 'assessment';
export const TASK_TYPE_CONFIRMATION = 'confirmation';
export const TASK_TYPE_PRACTICE = 'practice';
